import { Link } from 'react-router-dom'
import styles from './styles/NavMenu.css'
import * as analytics from 'lib/analytics'

export const NavMenu = ({ items }) => {
  const navClickWrapper = ({
    name,
    onClick = null
  }) => {
    analytics.event({
      category: 'Nav Dropdown',
      action: `Click ${name}`
    })

    if (onClick) {
      onClick()
    }
  }

  return (
    <div className={styles.navMenu}>
      {items
        .map(({ name, href, onClick, itemImg }) => {
          if (/^http/.test(href)) {
            return (
              <a
                key={name}
                className={styles.item}
                href={href}
                tabIndex={0}
                target='_blank'
                rel='noopener noreferrer'
              >
                {itemImg && (<img className={styles.navItemImg} src={itemImg} />)}
                <span className={styles.navItemCopy}>{name}</span>
              </a>
            )
          }
          if (href) {
            return (
              <Link
                key={name}
                className={styles.item}
                onClick={() => navClickWrapper({ name, onClick })}
                to={href || '#'}
              >
                {itemImg && (<img className={styles.navItemImg} src={itemImg} />)}
                <span className={styles.navItemCopy}>{name}</span>
              </Link>
            )
          }

          return (
            <a
              key={name}
              className={styles.item}
              onClick={() => navClickWrapper({ name, onClick })}
            >
              {itemImg && (<img className={styles.navItemImg} src={itemImg} />)}
              <span className={styles.navItemCopy}>{name}</span>
            </a>
          )
        })}
    </div>
  )
}

export default NavMenu
